import React from "react";

const PrimaryBtn = ({ type, bg, disabled = false, onClick, className = "", text }) => {
  // Determine if this is a transparent/outline style button
  const isOutline = bg === "transparent" || bg === "none";
  
  const buttonStyle = isOutline 
    ? { 
        backgroundColor: 'transparent', 
        color: '#0f172a', 
        border: '2px solid #e2e8f0' 
      }
    : { 
        backgroundColor: '#0f172a', 
        color: '#ffffff' 
      };
  
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`
        font-medium py-2.5 px-5 rounded-lg
        active:scale-[0.98]
        transition-all duration-150 ease-in-out
        disabled:opacity-50 disabled:cursor-not-allowed
        flex items-center justify-center gap-2
        hover:opacity-90
        ${className}
      `}
      style={buttonStyle}
    >
      {disabled ? (
        <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
        </svg>
      ) : (
        text
      )}
    </button>
  );
};

export default PrimaryBtn;
